<template>
  <base-content>
    <loan-applications />
  </base-content>
</template>

<script>
import LoanApplications from './LoanApplications.vue'

export default {
  name: 'AdminDashboard',

  components: {
    LoanApplications
  }
}
</script>
